import { render } from "./PrintLiquorLicense.vue?vue&type=template&id=1f53130f&scoped=true"
import script from "./PrintLiquorLicense.vue?vue&type=script&lang=js"
export * from "./PrintLiquorLicense.vue?vue&type=script&lang=js"

import "./PrintLiquorLicense.vue?vue&type=style&index=0&id=1f53130f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f53130f"]])

export default __exports__